import { useUIComponentsContext } from '../../Provider/UiComponentsProvider'
import { useAccessContext } from '../AccessProvider'
import ContributorContainer from '../Components/ContributorContainer'
import UserContributor from '../Components/UserContributor'
import UserDropdown from '../Components/UserDropdown'
import useContributorActions from '../hooks/useContributorActions'
import { AccessAccount } from '../types'
import { CONTRIBUTOR_RIGHTS } from '../utils'

export interface IPrivateTab {
  resourceOwner: AccessAccount
  onOwnerChange?: (newOwner: AccessAccount) => void
}

const PrivateTab = ({ resourceOwner, onOwnerChange }: IPrivateTab) => {
  const { t } = useUIComponentsContext()
  const { userContributors } = useAccessContext()

  const { OWNER } = CONTRIBUTOR_RIGHTS(t)

  const { handleAddTeam, handleAddUser, ...rest } = useContributorActions(
    'User',
    resourceOwner
  )

  return (
    <>
      {resourceOwner && (
        <ContributorContainer
          title={t?.('access.owner')}
          containerClassName="bg-oxford-gray-50"
          contributors={
            <UserContributor
              key={resourceOwner.id}
              account={resourceOwner}
              access={OWNER.value}
              onOwnerChange={onOwnerChange}
            />
          }
        />
      )}

      <div className="py-3">
        <div className="text-oxford-gray-400 uppercase mb-2 text-xs">
          {t?.('access.users')}
        </div>
        {!!userContributors?.length && (
          <div className="pb-3 flex flex-col gap-3">
            {userContributors.map(({ account, access, ...restUser }) => (
              <UserContributor
                key={account.id}
                account={account}
                access={access}
                {...restUser}
                {...rest}
              />
            ))}
          </div>
        )}

        <UserDropdown onChange={handleAddUser} />
      </div>
    </>
  )
}

export default PrivateTab
